var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 0.916667C11.6025 0.7125 10.8909 0.625 10.2084 0.625C9.07087 0.625 7.84587 0.858333 7.00004 1.5C6.15421 0.858333 4.92921 0.625 3.79171 0.625C2.65421 0.625 1.42921 0.858333 0.583374 1.5V10.0458C0.583374 10.1917 0.729207 10.3375 0.875041 10.3375C0.933374 10.3375 0.962541 10.3083 1.02087 10.3083C1.80837 9.92917 2.94587 9.66667 3.79171 9.66667C4.92921 9.66667 6.15421 9.9 7.00004 10.5417C7.78754 10.0458 9.21671 9.66667 10.2084 9.66667C11.1709 9.66667 12.1625 9.84167 12.9792 10.2792C13.0375 10.3083 13.0667 10.3083 13.125 10.3083C13.2709 10.3083 13.4167 10.1625 13.4167 10.0167V1.5C13.0667 1.2375 12.6875 1.0625 12.25 0.916667ZM12.25 8.79167C11.6084 8.5875 10.9084 8.5 10.2084 8.5C9.21671 8.5 7.78754 8.87917 7.00004 9.375V2.66667C7.78754 2.17083 9.21671 1.79167 10.2084 1.79167C10.9084 1.79167 11.6084 1.87917 12.25 2.08333V8.79167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNews);
export default __webpack_public_path__ + "static/media/addNews.5d5dd6c02644f6426ae9771b9a155c55.svg";
export { ForwardRef as ReactComponent };